import React from 'react';
import { CustomButton } from '@Modules/core/components';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import {
  IUsersConsultationLogDatatable,
  UsersConsultationLogDatatable,
} from './UsersConsultationLogDatatableHandlerMeta';
import ConsultationLogFileFormUI from '@Modules/admin/users/components/formsUI/ConsultationLogFileFormUI';
import { useMutation } from '@tanstack/react-query';
import * as UsersApi from '@Modules/admin/users/api/UsersApi';
import ConsultationLogFormMeta from './UsersConsultationFormMeta';

export default function UsersConsultationLogDatatableHandler() {
  const data: IUsersConsultationLogDatatable[] = [
    {
      login: 'HPX',
      username: 'HPX',
      menuOption: 'LOG FILE INQUIRY',
      accessType: 'CONNECTED',
      date: '30/06/2022',
      time: '12:24',
    },
  ];

  const formUIRef = React.useRef<any>(null);
  const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);

  // const toast = useToast();

  const { isLoading, mutate } = useMutation(UsersApi.createProfile, {
    onSuccess: (data) => {
      // console.log('Response: ', data);
      // toast({
      //   position: 'top-right',
      //   title: 'Votre mot de pass a été changé',
      //   isClosable: true,
      //   status: 'success',
      // });
    },
    onError: (error) => {
      console.log('Error: ', error);
    },
  });

  const onSubmit = (payload: any) => {
    console.log('payload: ', payload);
    setIsSubmitting(true);
    // console.log('payload: ', payload);
    setTimeout(() => {
      mutate(payload);
      setIsSubmitting(false);
      formUIRef?.current?.reset();
    }, 2000);
  };

  return (
    <>
      <CC.Box>
        <CC.Box mb="4">
          <ConsultationLogFileFormUI
            ref={formUIRef}
            isLoading={isLoading}
            isSubmitting={isSubmitting}
            meta={ConsultationLogFormMeta}
            onSubmit={onSubmit}
          />
        </CC.Box>

        <CustomReactTable
          data={data}
          columns={UsersConsultationLogDatatable.columns()}
        />
        <CC.Flex justifyContent="flex-end" my="2">
          <CustomButton>Enregistrer</CustomButton>
        </CC.Flex>
      </CC.Box>
    </>
  );
}
